<script>
  import { selectedFacets } from './stores/facet-store.js';
  import handleize from '../../utils/handleize.js';
  export let option;
  export let attribute;

  const { value } = option;
  $: isSelected = false;

  function handleCheckboxToggle(e) {
    selectedFacets.toggle(...e.target.getAttribute("value").split("::"));
    isSelected = !isSelected
  }

  window.addEventListener('facets:clear', () => {
    isSelected = false;
  });
</script>

<li class="flex items-center space-x-[12px]">
  <input
    type="checkbox"
    checked={isSelected}
    on:input={handleCheckboxToggle}
    id="{`facets_${attribute}_${handleize(option.value)}`}"
    name="{attribute}"
    class="cursor-pointer"
    value={`${attribute}::${option.value}`}
  />

  <label
    for="{`facets_${attribute}_${handleize(option.value)}`}"
    class={`text-b2 font-body ${isSelected ? 'font-medium text-accent-blue' : 'font-normal text-brand-blue'}`}
  >
    {#if attribute === 'reviews_average_score_titles'}
      {#if value === 'fivestar'}
        ★★★★★
      {:else if value === 'fourstar'}
        ★★★★
      {:else if value === 'threestar'}
        ★★★
      {:else if value === 'twostar'}
        ★★
      {:else if value === 'onestar'}
        ★
      {:else if value === 'nostar'}
        No Stars
      {/if}
    {:else}
      {value}
    {/if}
  </label>
</li>